import {
  ButtonBox,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ConfirmationDialogProps {
  text: string;
  modalCallback: () => void;
  open: boolean;
  handleClose: () => void;
}

export default function ConfirmationVisibilityDialog({
  text,
  modalCallback,
  open,
  handleClose,
}: ConfirmationDialogProps): JSX.Element {
  const handleConfirm = (): void => {
    modalCallback();
    handleClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirmation dialog"
    >
      <DialogContainer>
        <TextTypography>
          Você gostaria de {text} o comunicado para os credenciados?
        </TextTypography>
        <ButtonBox>
          <OutlinedButton onClick={handleClose}>Não</OutlinedButton>
          <FilledButton onClick={handleConfirm}>Sim</FilledButton>
        </ButtonBox>
      </DialogContainer>
    </StyledDialog>
  );
}
